// Service Studio créatif IA (génération par lot + briefing).
import { getRequest, postRequest } from "./api/apiService";

// `model` (id du catalogue Studio) fait foi pour le coût en crédits côté serveur.
// `sourceImage` (optionnel) : retouche image-to-image d'une créa déjà générée.
export const generateBatch = ({ prompt, count, aspectRatio, type, model, sourceImage }) =>
  postRequest("/api/creative/batch", { prompt, count, aspectRatio, type, model, sourceImage });

// Génération unitaire (avatar, voix off, édition vidéo) — pas de lot, un seul appel.
// type: 'avatar' | 'voiceover' | 'edit-video'. `voiceCloneId` (voiceover, optionnel) :
// utilise une voix clonée (POST /voice-clone) à la place d'une voix prédéfinie Gemini.
export const generateOne = ({ type, prompt, aspectRatio, imageUrl, text, voice, model, voiceCloneId }) =>
  postRequest("/api/creative/generate", { type, prompt, aspectRatio, imageUrl, text, voice, model, voiceCloneId });

// Ad Briefing (étape Define) → brief enrichi + matrice 3×3
export const fetchBriefOptions = () => getRequest("/api/creative/brief-options");
export const buildBrief = (payload) => postRequest("/api/creative/brief", payload);
export const fetchAngles = () => getRequest("/api/creative/angles");

// Clonage vocal (Google Cloud TTS Chirp 3 Instant Custom Voice — accès sur liste
// blanche côté Google, voir googleVoiceCloneProvider.js). `referenceAudioBase64` et
// `consentAudioBase64` : contenu brut encodé en base64 (pas de préfixe data:URI).
export const cloneVoice = ({ label, referenceAudioBase64, consentAudioBase64, encoding, languageCode }) =>
  postRequest("/api/creative/voice-clone", { label, referenceAudioBase64, consentAudioBase64, encoding, languageCode });
export const fetchClonedVoices = () => getRequest("/api/creative/voice-clones");
